import CalendarInfoStoreIndex from './schema/CalendarInfoStoreIndex';
import { Calendar } from 'mini-event-to-calendar-association/lib/schema/Calendar';

export default class CalendarInfoStore {
    private calendars: Map<string, Calendar>;
    private storeIndexes: CalendarInfoStoreIndex[];
    private isReadyForUse: boolean = false;
    private storeReadyPromise = null;
    private storeReadyPromiseResolve = null;

    constructor() {
        this.calendars = new Map<string, Calendar>();
        this.storeIndexes = [];
    }

    addIndex(index: CalendarInfoStoreIndex) {
        this.storeIndexes.push(index);
    }

    addCalendarInfo(calendar: Calendar) {
        this.calendars.set(calendar.calculatedFolderId, calendar);
        this.storeIndexes.forEach(index => {
            index.onAddCalendarInfo(calendar);
        });
    }

    deleteCalendarInfo(calendar: Calendar) {
        this.calendars.delete(calendar.calculatedFolderId);
        this.storeIndexes.forEach(index => {
            index.onDeleteCalendarInfo(calendar);
        });
    }

    deleteCalendarInfoByFolderId(folderId: string) {
        if (this.calendars.has(folderId)) {
            this.deleteCalendarInfo(this.calendars.get(folderId));
        }
    }

    getAllCalendarInfo(): Calendar[] {
        const calendarInfos = [];
        this.calendars.forEach(cal => calendarInfos.push(cal));
        return calendarInfos;
    }

    getCalendarInfo(folderId: string): Calendar {
        return this.calendars.get(folderId);
    }

    setCalendarInfoReadyState(isReady: boolean) {
        this.isReadyForUse = isReady;
        if (isReady) {
            // In this case, the store is ready so the resolve method can be called
            // And any consumer waiting on the final list of calendar info can proceed further.
            this.storeReadyPromiseResolve?.();
            this.storeReadyPromiseResolve = null;
            this.storeReadyPromise = null;
        } else {
            // If not ready, time to create a promise which can be awaited by a consumer of the store.
            if (!this.storeReadyPromiseResolve) {
                // tslint:disable-next-line:promise-must-complete
                this.storeReadyPromise = new Promise((resolve, reject) => {
                    this.storeReadyPromiseResolve = resolve;
                });
            }
        }
    }

    isCalendarInfoReadyForUse(): boolean {
        return this.isReadyForUse;
    }

    async onCalendarInfoReadyForUse(): Promise<boolean> {
        if (!this.isReadyForUse) {
            await this.storeReadyPromise;
        }
        return Promise.resolve(true);
    }
}
